import {
  ALL_SUPPORTED_EXTENSIONS,
  MEDIA_FILE_EXTENSIONS,
  TEXT_FILE_EXTENSIONS,
  VIDEO_EXTENSIONS,
} from "@/domain/upload/value-objects/SupportedExtensions";

/**
 * Domain Service for file type inference
 * Single Source of Truth for file type logic
 * Clean Architecture - Domain Layer
 */
export class FileTypeDomainService {
  /**
   * Determine file type from extension
   */
  static inferFileType(
    extension?: string
  ): "audio" | "video" | "text" | undefined {
    if (!extension) return undefined;

    const ext = extension.toLowerCase().replace(".", "");

    // Check if it's video first (video formats take priority)
    if (VIDEO_EXTENSIONS.includes(ext)) {
      return "video";
    }

    // Check if it's text
    if (TEXT_FILE_EXTENSIONS.includes(ext)) {
      return "text";
    }

    // Check if it's audio (media files that aren't video)
    if (MEDIA_FILE_EXTENSIONS.includes(ext)) {
      return "audio";
    }

    return undefined;
  }

  /**
   * Check if extension is supported
   */
  static isSupportedExtension(extension?: string): boolean {
    if (!extension) return false;

    const ext = extension.toLowerCase().replace(".", "");
    return ALL_SUPPORTED_EXTENSIONS.includes(ext);
  }

  /**
   * Get allowed extensions for validation
   */
  static getAllowedExtensions(): string[] {
    return [...ALL_SUPPORTED_EXTENSIONS];
  }
}
